var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecFive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.66 58.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#060586;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.83,58.22c-3.77,0-6.83-3.06-6.83-6.83s3.06-6.83,6.83-6.83,6.83,3.06,6.83,6.83-3.06,6.83-6.83,6.83Zm0-12.24c-2.99,0-5.42,2.43-5.42,5.42s2.43,5.42,5.42,5.42,5.42-2.43,5.42-5.42-2.43-5.42-5.42-5.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.83,45.98c-.39,0-.71-.32-.71-.71v-4.88c0-.39,.32-.71,.71-.71s.71,.32,.71,.71v4.88c0,.39-.32,.71-.71,.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.94 41.01 6.83 37.35 4.72 41.01 8.94 41.01"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.83,35.94c-3.77,0-6.83-3.06-6.83-6.83s3.06-6.83,6.83-6.83,6.83,3.06,6.83,6.83-3.06,6.83-6.83,6.83Zm0-12.24c-2.99,0-5.42,2.43-5.42,5.42s2.43,5.42,5.42,5.42,5.42-2.43,5.42-5.42-2.43-5.42-5.42-5.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.83,23.7c-.39,0-.71-.32-.71-.71v-4.88c0-.39,.32-.71,.71-.71s.71,.32,.71,.71v4.88c0,.39-.32,.71-.71,.71Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "8.94 18.73 6.83 15.07 4.72 18.73 8.94 18.73"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.83,13.66C3.06,13.66,0,10.59,0,6.83S3.06,0,6.83,0s6.83,3.06,6.83,6.83-3.06,6.83-6.83,6.83ZM6.83,1.41C3.84,1.41,1.41,3.84,1.41,6.83s2.43,5.42,5.42,5.42,5.42-2.43,5.42-5.42S9.81,1.41,6.83,1.41Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecFive);
export default __webpack_public_path__ + "static/media/sec_five.6c5da46d5460f21660a1e2eac6870bad.svg";
export { ForwardRef as ReactComponent };